/* unplugin-vue-components disabled */import { render } from "./member_receive.vue?vue&type=template&id=86698f60&scoped=true"
import script from "./member_receive.vue?vue&type=script&lang=js"
export * from "./member_receive.vue?vue&type=script&lang=js"

import "./member_receive.vue?vue&type=style&index=0&id=86698f60&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86698f60"]])

export default __exports__